import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from './components/Home/Index';
import Actualites from './components/Actualites/Index';
import Rejoindre from './components/Rejoindre/Index';
import Formation from './components/Formation/Index';
import Contact from './components/Contact/Index';
import Antenne from './components/Antenne/Index';
import NotFound from "./components/NotFound";
import LegalNotice from "./components/LegalNotice";
import PrivacyPolicy from "./components/PrivacyPolicy";

export default function AppRoutes() {

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/actualites" element={<Actualites />} />
      <Route path="/nous-rejoindre" element={<Rejoindre />} />
      <Route path="/se-former" element={<Formation />} />
      <Route path="/nous-contacter" element={<Contact />} />

      <Route path="/mentions-legales" element={<LegalNotice />} />
      <Route path="/donnees-personnelles" element={<PrivacyPolicy />} />

      <Route path="/antenne/:id" element={<Antenne />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
